// Os menus ficam no body. A captura acontece antes dos stopPropagation do
// painel e dos cards; wheel também cobre o zoom do canvas (sem scroll nativo).
const registrations = new WeakMap();

export function registerReteSelectDismissal(select) {
  if (!select.overlayVisible || registrations.has(select)) return;

  const events = ["pointerdown", "click", "wheel", "scroll"];
  const options = { capture: true, passive: true };
  const cleanup = () => {
    events.forEach((type) =>
      document.removeEventListener(type, dismiss, options)
    );
    select.$off("hide", cleanup);
    select.$off("hook:beforeDestroy", cleanup);
    registrations.delete(select);
  };
  const dismiss = (event) => {
    const overlay = select.$refs.overlay;
    if (overlay?.contains(event.target)) return;
    if (
      ["pointerdown", "click"].includes(event.type) &&
      select.$refs.container?.contains(event.target)
    )
      return;
    if (select.overlayVisible) select.hide();
    cleanup();
  };

  registrations.set(select, cleanup);
  events.forEach((type) => document.addEventListener(type, dismiss, options));
  select.$once("hide", cleanup);
  select.$once("hook:beforeDestroy", cleanup);
}
